import { useState } from "react";
import { specializationOptions } from "../../../utils/constants";
import SelectBadges from "../../ui/SelectBadges";
import FilledButton from "../../ui/buttons/FilledButton";

const SearchBox = ({ onSearch }) => {
  const [specialization, setSpecialization] = useState([{ value: "", label: "الكل" }]);
  const [specialistName, setSpecialistName] = useState("");
  const [keywords, setKeywords] = useState("");

  const handleSearch = () => {
    onSearch(specialistName, specialization, keywords);
  };

  return (
    <div className='absolute bottom-[-200px] left-1/2 transform -translate-x-1/2 w-full px-40'>
      <div
        dir='rtl'
        className='bg-secondary p-[2.5rem] shadow-lg rounded-custom-40 flex space-x-2 min-h-[15rem]'
      >
        <div className='flex flex-col justify-between w-full'>
          <div className='flex flex-wrap justify-between gap-8 h-[4rem]'>
            <input
              type='text'
              placeholder='ادخل اسم المتخصص'
              className='flex-1 p-3 border border-gray-300 rounded-custom-16 outline-none text-custom-20'
              value={specialistName}
              onChange={(e) => setSpecialistName(e.target.value)}
            />
            <input
              type='text'
              placeholder='ادخل كلمات مفتاحية '
              className='flex-1 p-3 border border-gray-300 rounded-custom-16 outline-none text-custom-20'
              value={keywords}
              onChange={(e) => setKeywords(e.target.value)}
            />
            <FilledButton
              isButton
              text={"ابحث"}
              width={"w-24"}
              height={"h-full"}
              onClick={handleSearch}
            />
          </div>
          <div className='mt-7'>
            <p className='text-2xl mb-4'>اختر التخصص</p>
            <SelectBadges
              options={specializationOptions}
              values={specialization}
              handelChange={setSpecialization}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBox;
